import { render, staticRenderFns } from "./LessonPackagesDetails.vue?vue&type=template&id=261f8eb8&scoped=true"
import script from "./LessonPackagesDetails.vue?vue&type=script&lang=js"
export * from "./LessonPackagesDetails.vue?vue&type=script&lang=js"
import style0 from "./LessonPackagesDetails.vue?vue&type=style&index=0&id=261f8eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f8eb8",
  null
  
)

export default component.exports